import { useState } from 'react';

export default function CandidateImage({ src, alt, width = 80, height = 80, circle = false }) {
  const [broken, setBroken] = useState(false);

  if (!src || broken) {
    return (
      <div
        className={circle ? 'ev-vote-card__no-img' : 'ev-result-item__no-img'}
        style={{ width, height }}>
        <span>사진 없음</span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={circle ? 'ev-candidate-img' : 'ev-result-img'}
      style={{ width, height, objectFit: 'cover', borderRadius: circle ? '50%' : 0 }}
      onError={() => setBroken(true)}
    />
  );
}
